export const en_policies = {
  refund: {
    title: "Refund Policy",
    backToCheckout: "Back to checkout",
    backToHome: "Back to home",
    setupFeeNotice: "The €500 setup fee is non-refundable once development has commenced.",
    subscriptionNotice: "Subscription payments are non-refundable for billed periods.",
    exceptionalCircumstances: "Exceptional Circumstances",
    exceptionalText: "Dathent maintains discretionary authority in exceptional circumstances.",
    processTitle: "Refund Process",
    processText: "If you believe you have a valid case for a refund exception, please contact us at:",
    earlyTerminationTitle: "Early Termination",
    earlyTerminationText: "For information about early termination of the Infrastructure Commitment Model, please refer to the",
    termsLink: "Terms of Service",
    lastUpdated: "Last updated: February 2026"
  },
  privacy: {
    title: "Privacy Policy",
    backToCheckout: "Back to checkout",
    backToHome: "Back to home",
    dataControllerTitle: "Data Controller",
    companyName: "DATHENT SAX S.L.",
    nif: "NIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spain",
    dataCollectedTitle: "Data Collected",
    dataCollectedText: "We collect and process the following categories of personal data:",
    contactDetails: "Contact details (name, email, phone)",
    projectInfo: "Project information",
    commHistory: "Communication history",
    purposeTitle: "Purpose",
    purposeText: "Data is processed strictly for:",
    serviceDelivery: "Service delivery",
    clientComm: "Client communication",
    paymentProcessing: "Payment processing",
    operationalImprovement: "Operational improvement",
    paymentSecurityTitle: "Payment Security",
    paymentSecurityText1: "Payments are processed through",
    paymentSecurityText2: "Dathent does not store payment card information.",
    dataRightsTitle: "Data Rights",
    dataRightsText: "In accordance with GDPR, clients may request:",
    accessRight: "Access to their personal data",
    rectificationRight: "Rectification of inaccurate data",
    erasureRight: "Erasure of personal data",
    restrictionRight: "Restriction of processing",
    requestsLabel: "Requests:",
    dataRetentionTitle: "Data Retention",
    dataRetentionText: "Personal data is retained only as long as necessary for the purposes outlined above, or as required by applicable law.",
    thirdPartySharingTitle: "Third-Party Data Sharing",
    thirdPartySharingText: "We do not sell or share personal data with third parties, except as necessary for service delivery (e.g., payment processing via Stripe).",
    contactTitle: "Contact",
    contactText: "For any privacy-related inquiries, please contact:",
    lastUpdated: "Last updated: February 2026"
  },
  terms: {
    title: "Terms of Service",
    backToCheckout: "Back to checkout",
    backToHome: "Back to home",
    companyTitle: "1. Company",
    companyText: "This website and related services are operated by:",
    companyName: "DATHENT SAX S.L.",
    cif: "CIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spain",
    companyNote: "Services provided under Spanish law and registered with the Mercantile Registry of Alicante.",
    companyDesc: "Dathent provides structured website infrastructure and long-term technical support solutions for businesses.",
    serviceModelsTitle: "2. Service Models",
    serviceModelsText: "Dathent offers two commercial models:",
    fullDevTitle: "A. Full Development Model",
    fullDevPrice: "One-time payment: €1500",
    fullDevNoSubscription: "No subscription commitment.",
    fullDevDesc: "This model includes complete website delivery without long-term support obligation.",
    infraCommitTitle: "B. Infrastructure Commitment Model",
    infraSetup: "Initial setup: €500",
    infraSupport: "Ongoing infrastructure support: €50 per month",
    infraMinimum: "Minimum commitment: 12 months",
    infraDesc: "This model provides a discounted development price in exchange for a structured long-term support agreement.",
    infraNote: "The standard support rate is €150 per month. The €50 rate is a contractual incentive tied to the 12-month commitment.",
    commercialStructureTitle: "3. Commercial Structure",
    commercialPoint1: "The discounted development fee (€500) is not a standalone product.",
    commercialPoint2: "It is part of a structured infrastructure agreement.",
    commercialPoint3: "The economic value of the development remains €1500.",
    commercialPoint4: "The reduced entry price is granted in consideration of the 12-month commitment.",
    earlyTerminationTitle: "4. Early Termination",
    earlyTerminationText: "If the client terminates the support agreement before completing 12 months, the remaining economic value becomes due.",
    calculationTitle: "Calculation:",
    fullDevValue: "Full development value: €1500",
    paidAtSetup: "Amount paid at setup: €500",
    outstandingBalance: "Outstanding balance: €1000",
    settlementNote: "Upon settlement of this balance, the support agreement terminates and no further monthly charges apply.",
    deliveryFrameworkTitle: "5. Delivery Framework",
    deliveryText: "Development begins after payment confirmation and receipt of required materials.",
    deliveryTime: "Typical delivery time: from 1 week.",
    acceleratedDelivery: "Accelerated delivery may be possible depending on project scope.",
    timelinesDepend: "Timelines depend on client responsiveness and project complexity.",
    intellectualPropertyTitle: "6. Intellectual Property",
    ipText: "Full ownership of the developed website is transferred upon completion of the economic obligations under either:",
    ip12Months: "12-month infrastructure commitment",
    ipOr: "OR",
    ipFullPayment: "Full payment of €1500 total value",
    limitationTitle: "7. Limitation of Liability",
    limitationText: "DATHENT SAX S.L. is not liable for:",
    thirdPartyInterruptions: "Third-party service interruptions",
    hostingFailures: "Hosting provider failures",
    clientDelays: "Delays caused by incomplete client input",
    limitationNote: "Liability is limited to the value of the purchased service.",
    governingLawTitle: "8. Governing Law",
    governingLawText: "These Terms are governed by the laws of Spain.",
    lastUpdated: "Last updated: February 2026"
  },
  subscriptionPolicy: {
    title: "Subscription Agreement",
    backToCheckout: "Back to checkout",
    backToHome: "Back to home",
    infraSupportTitle: "1. Infrastructure Support",
    infraSupportText: "The infrastructure support service ensures:",
    techStability: "Technical stability",
    continuousMaintenance: "Continuous maintenance",
    minorAdjustments: "Minor functional adjustments",
    monitoring: "Monitoring and performance oversight",
    standardRate: "Standard rate: €150 per month.",
    discountedRateTitle: "2. Discounted Commitment Rate",
    discountedRateText: "The €50/month rate is granted exclusively under the Infrastructure Commitment Model.",
    minimumTerm: "Minimum term: 12 months.",
    discountedRateNote: "The discounted rate reflects a long-term cooperation structure.",
    billingStructureTitle: "3. Billing Structure",
    billing30Days: "Billing begins 30 days after the initial setup payment.",
    billingStripe: "Payments are processed securely via Stripe.",
    earlyExitTitle: "4. Early Exit Clause",
    earlyExitText: "If terminated before 12 months, the remaining economic value of €1000 becomes due.",
    earlyExitNote: "After settlement, no further subscription payments apply.",
    postCommitmentTitle: "5. Post-Commitment Phase",
    postCommitmentText: "After 12 months, the agreement continues month-to-month.",
    postCommitmentNote: "The client may terminate at any time without penalty.",
    lastUpdated: "Last updated: February 2026"
  },
  cookies: {
    title: "Cookie Policy",
    backToCheckout: "Back to checkout",
    backToHome: "Back to home",
    whatAreCookiesTitle: "What Are Cookies",
    whatAreCookiesText: "Cookies are small text files that are stored on your device when you visit a website. They help the website remember information about your visit.",
    essentialCookiesTitle: "Essential Cookies",
    essentialCookiesText: "This website uses essential cookies required for operation.",
    essentialCookiesNote: "These cookies are necessary for the website to function properly and cannot be disabled.",
    analyticsCookiesTitle: "Analytics Cookies",
    analyticsCookiesText: "Analytics cookies may be used to improve performance and understand how visitors interact with the website.",
    analyticsCookiesNote: "These cookies help us analyze website traffic and optimize user experience.",
    managingCookiesTitle: "Managing Cookies",
    managingCookiesText: "Users may disable non-essential cookies via browser settings.",
    chromeSettings: "Chrome: Settings → Privacy and security → Cookies",
    firefoxSettings: "Firefox: Settings → Privacy & Security → Cookies",
    safariSettings: "Safari: Preferences → Privacy → Cookies",
    disablingNote: "Note: Disabling essential cookies may affect website functionality.",
    thirdPartyCookiesTitle: "Third-Party Cookies",
    thirdPartyCookiesText: "We may use third-party services that set their own cookies:",
    stripeLabel: "Stripe – for payment processing",
    analyticsLabel: "Analytics tools – for performance monitoring",
    updatesTitle: "Updates to This Policy",
    updatesText: "We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.",
    contactTitle: "Contact",
    contactText: "For questions about our use of cookies, please contact:",
    lastUpdated: "Last updated: February 2026"
  }
};
